"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FixedToolbarTop = exports.FixedToolbarBottom = void 0;
var _cn = require("@udecode/cn");
var _toolbar = require("./toolbar");
var FixedToolbarTop = exports.FixedToolbarTop = (0, _cn.withCn)(_toolbar.Toolbar, 'supports-backdrop-blur:bg-background/60 sticky left-0 top-0 z-50 w-full justify-between overflow-x-auto rounded-t-lg border-b border-b-border bg-background/95 backdrop-blur');
var FixedToolbarBottom = exports.FixedToolbarBottom = (0, _cn.withCn)(_toolbar.Toolbar, 'supports-backdrop-blur:bg-background/60 sticky left-0 top-0 z-50 w-full justify-between overflow-x-auto rounded-b-lg border-t border-t-border bg-background/95backdrop-blur');